<template>
    <div>
        <b-row>
            <b-col cols="1">
                <b-badge variant="light">
                    Seg-{{ segment_index }}
                </b-badge>
            </b-col>
            <b-col cols="3">
                <label>
                    Data
                </label>
                <div class="service--flight--segment--departure">
                    <div class="date">
                        <b-form-group id="departure_date">
                            <b-input-group>
                                <b-form-input
                                    size="sm"
                                    id="departure_date"
                                    v-model="departure.at"
                                    placeholder="Orario"
                                    disabled
                                ></b-form-input>
                                <b-input-group-append>
                                <b-button variant="secondary" v-b-toggle="itinerary_index + '-' + segment_index + '-departure'"><font-awesome-icon icon="pencil-alt" /></b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <div class="date--friendly">{{ departure.friendly }}</div>
                            <b-collapse :id="itinerary_index + '-' + segment_index + '-departure'">
                                <div class="date--pickers">
                                    <date-time-picker
                                        :header="false"
                                        :smart_inputs="true"
                                        :day="departure.day"
                                        :hour="departure.hour"
                                        :context="{
                                            for: 'departure',
                                            itinerary_index: itinerary_index,
                                            segment_index: segment_index
                                        }"
                                        @updated="(value) => refresh_date({
                                                day: value.day,
                                                hour: value.hour,
                                                context: value.context
                                            })"
                                    />
                                </div>
                            </b-collapse>
                        </b-form-group>     
                    </div>
                </div>
            </b-col>
            <b-col cols="2">
                <label>
                    Aeroporto
                </label>
                <div class="service--flight--segment--departure">
                    <div class="place">
                        <b-form-group id="departure_airport">
                            <b-form-input
                                size="sm"
                                id="departure_airport"
                                v-model="departure.iata"
                                placeholder="codice IATA"
                                @input="updated"
                            ></b-form-input>
                        </b-form-group>            
                    </div>
                </div>
            </b-col>
            <b-col cols="1" class="text-center">
                <font-awesome-icon icon="minus" />
            </b-col>
            <b-col cols="3">
                <label>
                    Data
                </label>
                <div class="service--flight--segment--departure">
                    <div class="date">
                        <b-form-group id="arrival_date">
                            <b-input-group>
                                <b-form-input
                                    size="sm"
                                    id="arrival_date"
                                    v-model="arrival.at"
                                    placeholder="Orario"
                                    disabled
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button variant="secondary" v-b-toggle="itinerary_index + '-' + segment_index + '-arrival'"><font-awesome-icon icon="pencil-alt" /></b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <div class="date--friendly">{{ arrival.friendly }}</div>
                            <b-collapse :id="itinerary_index + '-' + segment_index + '-arrival'">
                                <div class="date--pickers">
                                    <date-time-picker
                                        :header="false"
                                        :smart_inputs="true"
                                        :day="arrival.day"
                                        :hour="arrival.hour"
                                        :context="{
                                            for: 'arrival',
                                            itinerary_index: itinerary_index,
                                            segment_index: segment_index
                                        }"
                                        @updated="(value) => refresh_date({
                                                day: value.day,
                                                hour: value.hour,
                                                context: value.context
                                            })"
                                    />
                                </div>
                            </b-collapse>
                        </b-form-group>                                
                    </div>
                </div>
            </b-col>
            <b-col cols="2">
                <label>
                    Aeroporto
                </label>
                <div class="service--flight--segment--departure">
                    <div class="place">
                        <b-form-group id="arrival_airport">
                            <b-form-input
                                size="sm"
                                id="arrival_date"
                                v-model="arrival.iata"
                                placeholder="codice IATA"
                                @input="updated"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="3" offset="1">
                <label>Compagnia</label>
                <div class="service--flight--segment--carrier">
                    <div class="carrier">
                        <b-form-group id="carrier">
                            <b-form-input
                                size="sm"
                                id="carrier"
                                v-model="carrier_code"
                                placeholder="Compagnia"
                                @input="updated"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
            </b-col>
            <b-col cols="3">
                <label>Numero volo</label>
                <!-- TODO class -->
                <div class="service--flight--segment--carrier">
                    <div class="carrier">
                        <b-form-group id="flight_number">
                            <b-form-input
                                size="sm"
                                id="flight_number"
                                v-model="flight_number"
                                placeholder="Numero volo"
                                @input="updated"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
            </b-col>
            <b-col cols="3">
                <label>Operato da</label>
                <div class="service--flight--segment--carrier">
                    <div class="carrier">
                        <b-form-group id="operating">
                            <b-form-input
                                size="sm"
                                id="operating"
                                v-model="operating"
                                placeholder="Operato da"
                                @input="updated"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import { parse_flight_offers_date } from '@/utilities'
    import DateTimePicker from '@/components/blocks/date-time-picker'
    export default {
        name: 'segment',
        components: {
            'date-time-picker': DateTimePicker,
        },
        props: {
            segment: {
                type: Object,
                default: () => {}
            },
            segment_index: Number,
            itinerary_index: Number,
        },
        data() {

            let parsed_departure_date = parse_flight_offers_date(this.segment.departure.at)
            let parsed_arrival_date = parse_flight_offers_date(this.segment.arrival.at)

            return {
                departure: {
                    iata: this.segment.departure.iataCode,
                    day: parsed_departure_date.day,
                    hour: parsed_departure_date.hour,
                    at: this.segment.departure.at,
                    friendly: this.get_friendly_date_time(parsed_departure_date.day,parsed_departure_date.hour),
                },
                arrival: {
                    iata: this.segment.arrival.iataCode,
                    day: parsed_arrival_date.day,
                    hour: parsed_arrival_date.hour,
                    at: this.segment.arrival.at,
                    friendly: this.get_friendly_date_time(parsed_arrival_date.day,parsed_arrival_date.hour),
                },
                carrier_code: this.segment.carrierCode,
                operating: this.operating ? this.operating : '',
                flight_number: this.segment.flight_number,
            }
        },
        created()
        {
            this.parse_flight_offers_date = parse_flight_offers_date
        },
        mounted()
        {
        },
        methods:
        {
            get_friendly_date_time(date,time)
            {
                return 'giorno: ' + date + ' - ora: ' + time
            },
            refresh_date(payload)
            {    
                this[payload.context.for].day = payload.day
                this[payload.context.for].hour = payload.hour
                this[payload.context.for].at = payload.day+'T'+payload.hour
                this[payload.context.for].friendly = this.get_friendly_date_time(payload.day,payload.hour)
                this.updated()
                /*
                let day = payload.day,
                    hour = payload.hour,
                    context = payload.context,
                    itinerary_index = context.itinerary_index,
                    segment_index = context.segment_index,
                    itinerary = this.flight_service.details.itineraries.filter(function(i){ return i.itinerary_index == itinerary_index })[0],
                    segment = itinerary.segments.filter(function(s){ return s.segment_index == segment_index })[0]

                segment[context.for].day = day
                segment[context.for].hour = hour
                segment[context.for].at = day+'T'+hour
                segment[context.for].friendly = segment.departure.day + ' - ' + segment.departure.hour
                this.update_service()
                */
            },
            updated()
            {
                let payload = {
                    itinerary_index: this.itinerary_index,
                    segment: {
                        ...this.segment,
                        departure: {
                            iataCode: this.departure.iata,
                            at: this.departure.at,
                        },
                        arrival:
                        {
                            iataCode: this.arrival.iata,
                            at: this.arrival.at,
                        },
                        carrierCode: this.carrier_code,
                        operating:{
                            carrierCode: this.operating ? this.operating : this.carrier_code // se non specificato operato da chi vende
                        },
                        flight_number: this.flight_number

                    }
                }
                this.$emit('updated', payload)
            },
            removed()
            {
                let payload = {
                    itinerary_index: this.itinerary_index,
                    segment_index: this.segment_index,
                }
                this.$emit('removed', payload)
            }
        }
    }
</script>

<style lang="scss">
    .service--flight--segment
    {
        &:not(:last-child)
        {
            border-bottom:1px solid rgba($info,0.25);
            border-right:1px solid rgba($info,0.25);
        }
        padding:$grid-gutter-width/2 $grid-gutter-width/2 0 $grid-gutter-width/2;
        &--carrier
        {
            text-align: left;
            .carrier
            {
                color:$primary;
                font-weight:bold;
            }
        }
        &--info
        {
            padding:1rem;
        }
        &--arrival,
        &--departure
        {
            .date
            {
                &--friendly
                {
                    display: block;
                    clear:both;
                    margin:0.5rem 0;
                    font-size:11px;
                    text-align: left;
                    color:$secondary;
                }
            }
            .place
            {
                width:100%;
                display:flex;
                align-items: center;
                white-space: nowrap;
                .form-group
                {
                    width:100%;
                }
            }
            &>.service--field--title
            {
                text-align:left;
            }
            .date,
            .place
            {
                margin-bottom:0.5rem;
                font-size: 14px;
                .service--field--title
                {
                    min-width: 120px;
                    margin-right:1rem;
                    margin-bottom:0;
                }
            }
        }        
        .place,
        .date
        {
            .form-group
            {
                display:flex;
                flex-wrap: wrap;
                label
                {
                    width:140px;
                }
                &>div
                {
                    flex:1;
                }
            }
        }
        .service--field--title
        {
            margin-bottom:1rem;
        }
        .date,
        .time
        {
            flex:1;
        }
    }

    .service--segment--remove
    {
        @extend .service--item--remove !optional;
        text-align: right;
        margin-bottom: 1rem;
        cursor:pointer;
    }
    .service--segment--add
    {
        @extend .service--item--add !optional;
        margin:1rem;
        text-align: left;
        cursor:pointer;
    }        
</style>